module.exports = __webpack_public_path__ + "static/media/post-placeholder.c0be0b29.png";